import React from 'react';
import { useTranslation } from '../../i18n';
import SectionTag from '../common/SectionTag';

const Objectifs = () => {
  const { t } = useTranslation();

  const objectives = Array.from({ length: 8 }, (_, i) => ({
    num: String(i + 1).padStart(2, '0'),
    key: `obj${i + 1}`,
  }));

  return (
    <section className="bg-white px-4 md:px-10 py-20">
      <div className="max-w-7xl mx-auto">
        <SectionTag>{t('objectifs_tag')}</SectionTag>
        <h2 className="font-playfair text-3xl md:text-4xl font-bold mb-0">
          {t('objectifs_title')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {objectives.map((obj) => (
            <div
              key={obj.num}
              className="p-7 border border-ofd-gray-light rounded relative overflow-hidden transition-all duration-200 hover:shadow-lg hover:-translate-y-1"
            >
              <div className="absolute top-0 left-0 w-full h-1 bg-ofd-blue" />
              <div className="font-playfair text-3xl font-black text-ofd-gray-light leading-none mb-2">
                {obj.num}
              </div>
              <p className="text-ofd-gray text-sm">{t(obj.key)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Objectifs;